import HomeworkService from '@/services/homework.service';
import axios from "axios";

export const homeworkModule = {
    namespaced: true,
    state: {
        requests: [],
        homework: {},
        homeworks: new Map(),
        submitted: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createHomework({commit, dispatch}, {classId, sessionId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createHomework");
            return HomeworkService.createHomework(axiosSource, classId, sessionId, data).then(
                async data => {
                    commit('insertHomework', data)
                    await dispatch('clearRequest', "createHomework");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateHomework({commit, dispatch}, {classId, sessionId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateHomework");
            return HomeworkService.updateHomework(axiosSource, classId, sessionId, data).then(
                async data => {
                    commit('updateHomeworkData', data)
                    await dispatch('clearRequest', "updateHomework");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteHomework({commit, dispatch}, {classId, sessionId, homeworkId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteHomework");
            return HomeworkService.deleteHomework(axiosSource, classId, sessionId, homeworkId).then(
                async data => {
                    commit('removeHomeworkFromList', homeworkId)
                    await dispatch('clearRequest', "deleteHomework");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getHomework({commit, dispatch}, {classId, sessionId, homeworkId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getHomework");
            return HomeworkService.getHomework(axiosSource, classId, sessionId, homeworkId).then(
                async data => {
                    commit('updateActiveHomework', data)
                    await dispatch('clearRequest', "getHomework");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listHomeworks({commit, dispatch}, {classId, sessionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listHomeworks");
            return HomeworkService.listHomeworks(axiosSource, classId, sessionId).then(
                async data => {
                    commit('updateHomeworksList', data);
                    await dispatch('clearRequest', "listHomeworks");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listUserHomeworks({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listUserHomeworks");
            return HomeworkService.listUserHomeworks(axiosSource).then(
                async data => {
                    commit('updateHomeworksList', data);
                    await dispatch('clearRequest', "listUserHomeworks");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async submitHomework({commit, dispatch}, {classId, sessionId, homeworkId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "submitHomework");
            return HomeworkService.submitHomework(axiosSource, classId, sessionId, homeworkId, data).then(
                async data => {
                    commit('submitHomework', data)
                    await dispatch('clearRequest', "submitHomework");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async submitted({commit, dispatch}, {classId, sessionId, homeworkId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "homeworkSubmitted");
            return HomeworkService.submitted(axiosSource, classId, sessionId, homeworkId).then(
                async data => {
                    commit('updateSubmitted', data)
                    await dispatch('clearRequest', "homeworkSubmitted");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateHomeworksList(state, data) {
            state.homeworks = new Map()
            for (const entity of data) {
                state.homeworks.set(entity.id, entity)
            }
        },
        updateSubmitted(state, data) {
            state.submitted = new Map()
            for (const entity of data) {
                state.submitted.set(entity.created_at, entity)
            }
        },
        insertHomework(state, data) {
            state.homeworks.set(data.id, data)
        },
        updateHomeworkData(state, data) {
            state.homeworks.set(data.id, data)
        },
        removeHomeworkFromList(state, homeworkId) {
            state.homeworks.delete(homeworkId)
        },
        updateActiveHomework(state, data) {
            state.homework = data;
        }
    }
};